import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-preview',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (filePreviewUrl) {
      <div [class]="containerClass">
        <label class="block text-sm font-medium mb-1.5 text-zinc-700 dark:text-zinc-300" *ngIf="showLabel">
          {{ label }}
        </label>
        <div class="border border-zinc-200 dark:border-zinc-700 rounded-xl overflow-hidden shadow-sm"
             [style.height]="height">
          <iframe
            [src]="filePreviewUrl"
            frameborder="0"
            width="100%"
            height="100%"
            title="File Preview"
          ></iframe>
        </div>
      </div>
    }
    @if (!filePreviewUrl && selectedFile) {
      <div class="flex flex-col items-center justify-center border border-zinc-200 dark:border-zinc-700 rounded-xl bg-zinc-50 dark:bg-zinc-800"
           [style.height]="height">
        <div class="animate-spin rounded-full h-6 w-6 border-2 border-zinc-200 dark:border-zinc-600 border-t-blue-600 mb-3"></div>
        <p class="text-sm text-zinc-500 dark:text-zinc-400">Generating preview...</p>
      </div>
    }
    @if (!selectedFile && !isEditMode) {
      <div class="flex flex-col items-center justify-center border-2 border-dashed border-zinc-200 dark:border-zinc-600 rounded-xl bg-zinc-50/50 dark:bg-zinc-800/50"
           [style.height]="height">
        <svg class="h-10 w-10 text-zinc-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
        </svg>
        <p class="text-sm font-medium text-zinc-500 dark:text-zinc-400">Select a file to preview</p>
        <p class="text-xs text-zinc-400 dark:text-zinc-500 mt-1">Upload a PDF document to see it here</p>
      </div>
    }
  `
})
export class PdfPreviewComponent {
  @Input() filePreviewUrl: SafeResourceUrl | null = null;
  @Input() selectedFile: File | null = null;
  @Input() isEditMode = false;
  @Input() height = 'calc(100vh - 300px)';
  @Input() label = 'File Preview';
  @Input() showLabel = true;
  @Input() containerClass = 'sticky top-4 self-start';
}
